import React, { useCallback, useEffect } from "react";
import { AccountContact } from "../../../api/services";
import {
  Typography,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  withStyles,
  FormHelperText,
} from "@material-ui/core";

import { useFormContext } from "react-hook-form";

const CustomFormControlLabel = withStyles(() => ({
  root: {
    minWidth: 120,
  },
}))(FormControlLabel);

export const DeliveryMethods: React.FC<AccountContact> = ({
  isPrimary,
  billDelivery,
  commDelivery,
  forename,
  surname,
}) => {
  const { register, errors, setValue, getValues } = useFormContext();

  const isNotEmpty = useCallback((values: []) => {
    return values?.length > 0 ? true : "This field is required";
  }, []);

  const handleChange = useCallback(
    (group: string) => (e: React.FormEvent<HTMLFieldSetElement>) => {
      // Relying name to handle change - make sure CheckBox[name] matches delivery enum type, e.g., Post., Email or SMS
      const { checked, name } = e.target as any;
      const values = (getValues(group) || []).filter((n: string) => n !== name);
      if (checked) {
        values.push(name);
      }
      setValue(group, values, checked);
    },
    [getValues, setValue],
  );

  useEffect(() => {
    setValue("billDelivery", billDelivery);
    setValue("commDelivery", commDelivery);
  }, [billDelivery, commDelivery, setValue]);

  return (
    <>
      <Typography variant="body1">
        {forename || surname || "The contact"} is{" "}
        {isPrimary ? "the primary" : "a secondary"} contact for this account.
      </Typography>
      <Box mt={2}>
        <FormControl
          component="fieldset"
          fullWidth
          onChange={handleChange("billDelivery")}
          required={isPrimary}
          name="billDelivery"
          error={errors?.billDelivery !== undefined}
          ref={(el: HTMLFieldSetElement | null) =>
            el &&
            register(el, {
              validate: isPrimary ? isNotEmpty : undefined,
            })
          }
        >
          <FormLabel component="label">
            <Typography component="span" variant="body1" color="textPrimary">
              {`Bill delivery${isPrimary ? "" : " (copy of bills)"}`}
            </Typography>
          </FormLabel>
          <FormGroup row={true}>
            <CustomFormControlLabel
              control={
                <Checkbox
                  defaultChecked={billDelivery.includes("Post")}
                  name="Post"
                />
              }
              label="Post"
            />
            <CustomFormControlLabel
              control={
                <Checkbox
                  defaultChecked={billDelivery.includes("Email")}
                  name="Email"
                />
              }
              label="Email"
            />
          </FormGroup>
          <FormHelperText>{errors?.billDelivery?.message}</FormHelperText>
        </FormControl>
      </Box>
      <Box mt={2}>
        <FormControl
          component="fieldset"
          fullWidth
          name="commDelivery"
          onChange={handleChange("commDelivery")}
          ref={register}
        >
          <FormLabel component="label">
            <Typography component="span" variant="body1" color="textPrimary">
              Communication delivery
            </Typography>
          </FormLabel>
          <FormGroup row={true}>
            <CustomFormControlLabel
              control={
                <Checkbox
                  defaultChecked={commDelivery.includes("Post")}
                  name="Post"
                />
              }
              label="Post"
            />
            <CustomFormControlLabel
              control={
                <Checkbox
                  defaultChecked={commDelivery.includes("Email")}
                  name="Email"
                />
              }
              label="Email"
            />
            <CustomFormControlLabel
              control={
                <Checkbox
                  defaultChecked={commDelivery.includes("SMS")}
                  name="SMS"
                />
              }
              label="SMS"
            />
          </FormGroup>
        </FormControl>
      </Box>
    </>
  );
};
